/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Attendance_YesInputs */

const en_admin_statistics_attendance_yes = /** @type {(inputs: Admin_Statistics_Attendance_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attended`)
};

const de_admin_statistics_attendance_yes = /** @type {(inputs: Admin_Statistics_Attendance_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stattgefunden`)
};

/**
* | output |
* | --- |
* | "Attended" |
*
* @param {Admin_Statistics_Attendance_YesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_attendance_yes = /** @type {((inputs?: Admin_Statistics_Attendance_YesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Attendance_YesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_attendance_yes(inputs)
	return en_admin_statistics_attendance_yes(inputs)
});